var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { staticClass: "row no-gutters pt-2" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("client-board-states-bar", {
            attrs: {
              loading: _vm.loading,
              "board-id": _vm.selectedBoardId,
              states: _vm.orderedStatuses,
            },
            on: { submit: _vm.handleStatusEdit },
          }),
          _vm._v(" "),
          _c("client-profiles-table", {
            attrs: {
              loading: _vm.loading,
              profiles: _vm.PROFILES,
              "status-name-list": _vm.statusNameList,
              states: _vm.orderedStatuses,
              boards: _vm.BOARDS,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }